import React from 'react';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { AppBar, Toolbar, Typography, IconButton, MenuItem, Menu, Box, Avatar } from '@mui/material';

import styles from './styles';

import { userState } from '../../states/auth';
import logo from '../../logo.svg';

export default function Header() {
  const user = useRecoilValue(userState);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    setAnchorEl(null);
    window.location.href = `${import.meta.env.REACT_APP_OAUTH_URL}/login?logout=true&next=${encodeURI(window.location.href)}`;
  };

  const name = user.userInfo?.name || user.user?.name;
  return (
    <Box sx={styles.root}>
      <AppBar color="default" position="static">
        <Toolbar>
          <Box>
            <Link to={'/'}>
              <img alt="Jitsu logo" height="40px" src={logo} />
            </Link>
          </Box>
          <Typography variant="h6" sx={styles.title}>
            ADDRESS TOOLS
          </Typography>
          {user.user && (
            <div>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-app-bar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
                sx={styles.accountButton}
              >
                <Avatar
                  alt={name}
                  src={user.userInfo?.avatar_url}
                  sx={{ width: '24px', height: '24px', marginRight: 1, bgcolor: 'primary.main' }}
                >
                  {name?.[0]?.toUpperCase()}
                </Avatar>
                <Box component="span" sx={styles.username}>{user.userInfo ? user.userInfo.nickname : user.user.name}</Box>
              </IconButton>
              <Menu
                id="menu-app-bar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={logout}>Logout</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
